"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.paddingMap = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var Typography_1 = __importDefault(require("../Typography"));
var Icon_1 = __importDefault(require("../Icon"));
var Spinner_1 = __importDefault(require("../Spinner"));
var react_1 = require("@emotion/react");
var defaultProps = {
    variant: 'main',
    size: 'lg',
    margin: 'none',
    width: 'auto',
};
exports.paddingMap = {
    lg: '14px 20px',
    md: '10px 20px',
    sm: '6px 20px',
};
var getCSSRules = function (props, theme) { return ({
    button: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'inherit',
        borderRadius: props.size === 'lg' ? theme.borderRadius.md : theme.borderRadius.sm,
        padding: exports.paddingMap[props.size || 'lg'],
        margin: "".concat(theme.margins[props.margin || 'md'], "px 0"),
        color: theme.colors.Grey[0],
        width: props.width === 'fixed' ? 140 : 'auto',
        border: 'none',
        cursor: 'pointer',
        transition: 'all ease .2s',
        '&:disabled': {
            cursor: 'default',
            pointerEvents: 'none',
        },
        '&.main': {
            background: theme.colors.Hannibal.default,
            color: theme.colors.Grey[0],
            '&:disabled': {
                background: theme.colors.Hannibal[200],
            },
            '&:hover': {
                background: theme.colors.Hannibal.hover,
            },
            '&:active': {
                background: theme.colors.Hannibal.active,
            },
        },
        '&.secondary': {
            background: theme.colors.Grey[200],
            color: theme.colors.Grey[700],
            '&:disabled': {
                color: theme.colors.Grey[400],
            },
            '&:hover': {
                background: theme.colors.Grey.hover,
            },
            '&:active': {
                background: theme.colors.Grey.active,
            },
        },
        '&.ghost': {
            background: 'transparent',
            border: "1px solid ".concat(theme.colors.Grey[700]),
            color: theme.colors.Grey[700],
            '&:disabled': {
                color: theme.colors.Grey[400],
                borderColor: theme.colors.Grey[300],
            },
            '&:hover': {
                borderColor: theme.colors.Grey[800],
            },
        },
        '&.positive': {
            background: theme.colors.Green.default,
            color: theme.colors.Grey[0],
            '&:disabled': {
                background: theme.colors.Green[200],
            },
            '&:hover': {
                background: theme.colors.Green.hover,
            },
            '&:active': {
                background: theme.colors.Green.active,
            },
        },
        '&.negative': {
            background: theme.colors.Red.default,
            color: theme.colors.Grey[0],
            '&:disabled': {
                background: theme.colors.Red[200],
            },
            '&:hover': {
                background: theme.colors.Red.hover,
            },
            '&:active': {
                background: theme.colors.Red.active,
            },
        },
        '&.loading': {
            background: theme.colors.Grey[0],
            color: theme.colors.Grey[900],
            boxShadow: '0px 1px 8px rgba(0, 0, 0, 0.1)',
            pointerEvents: 'none',
        },
    },
    spinner: {
        marginRight: 6,
    },
}); };
var Button = function (props) {
    var theme = (0, react_1.useTheme)();
    var styles = getCSSRules(props, theme);
    var children = props.children, variant = props.variant, size = props.size, loading = props.loading, iconProps = props.iconProps, className = props.className, rest = __rest(props, ["children", "variant", "size", "loading", "iconProps", "className"]);
    return ((0, jsx_runtime_1.jsxs)("button", __assign({ css: (0, react_1.css)(styles.button, loading ? loading : undefined), className: (0, classnames_1.default)(variant, className) }, rest, { children: [loading ? ((0, jsx_runtime_1.jsx)(Spinner_1.default, { css: (0, react_1.css)(styles.spinner), size: size === 'sm' ? 'sm' : 'md' }, void 0)) : iconProps ? ((0, jsx_runtime_1.jsx)(Icon_1.default, __assign({ size: size === 'sm' ? 'sm' : 'md', color: 'inherit' }, iconProps, { style: { marginRight: 6 } }), void 0)) : null, (0, jsx_runtime_1.jsx)(Typography_1.default, __assign({ variant: size === 'sm' ? 'textSmall' : 'textMedium', weight: 'bold' }, { children: loading ? 'Loading...' : children }), void 0)] }), void 0));
};
Button.defaultProps = defaultProps;
exports.default = Button;
//# sourceMappingURL=index.js.map